import {Controller} from '@hotwired/stimulus'

const sibling = (input, kind) => input.closest('tr').querySelector(`[data-grant-picker-kind="${kind}"]`)

// Grant picker (GF-3069): marks the chosen mode's card, shows the per-role grid
// only in selected-roles mode and keeps write ⇒ read in the browser; the server
// enforces the same rule. The grid is a fieldset disabled along with hiding, so
// a hidden grid never submits. Read-only (GF-3904) disables every per-role
// write box, so a read-only set never submits a write grant.
export default class extends Controller {
  static targets = ['mode', 'option', 'roles', 'write', 'readOnly']

  static classes = ['selected']

  connect() {
    this.modeChanged()
    this.readOnlyChanged()
  }

  modeChanged() {
    const selected = this.modeTargets.find((radio) => radio.checked)
    const off = !(selected && selected.value === 'selected_roles')
    this.rolesTarget.hidden = off
    this.rolesTarget.disabled = off
    if (this.hasSelectedClass) {
      this.optionTargets.forEach((option) => {
        option.classList.toggle(this.selectedClass, option.contains(selected))
      })
    }
  }

  readOnlyChanged() {
    const readOnly = this.hasReadOnlyTarget && this.readOnlyTarget.checked
    this.writeTargets.forEach((box) => {
      if (readOnly)
        box.checked = false
      box.disabled = readOnly
    })
  }

  // eslint-disable-next-line class-methods-use-this
  writeChanged(event) {
    if (event.target.checked)
      sibling(event.target, 'read').checked = true
  }

  // eslint-disable-next-line class-methods-use-this
  readChanged(event) {
    if (!event.target.checked)
      sibling(event.target, 'write').checked = false
  }
}
